import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import { TagPayload } from '@/common/write.types';
import store from '../index';
import Tag from '../../common/model/Tag';
import TagService from '../../common/api/tag.service';
import brandModule from './brand.module';


@Module({ dynamic: true, store, name: 'tag' })
class TagModule extends VuexModule {
  tags: Array<Tag> = [];

  service = new TagService();

  @Mutation
  SET_ALL_TAGS(tag: Array<Tag>) {
    this.tags = tag;
  }

  @Mutation
  ADD_TAG(tag: Tag) {
    this.tags.push(tag);
  }

  @Action
  async fetchTags(): Promise<void> {
    if (!brandModule.brand) { return; }
    const response = await this.service.fetchAllTags(brandModule.brand.id);
    if (!response) { return; }
    this.SET_ALL_TAGS(response.data.data.tags);
  }

  @Action
  async createTag(tagPayload: TagPayload): Promise<void> {
    if (!brandModule.brand) { return; }
    const response = await this.service.createTag(tagPayload);
    if (!response) { return; }
    this.ADD_TAG(response.data.data.tag);
  }
}

export default getModule(TagModule);
